import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PagesContainerComponent } from '../components/pages-container/pages-container.component';
import { PageContainerService } from '../components/pages-container/services/page-container.service';
import { PageContainerConfigurations } from '../components/pages-container/interfaces/PageContainerConfiguration.interface';
import {
  NavigationItem,
  RoutePath,
} from '../components/pages-container/interfaces/navigationList.interface';
import { PermissionsService } from '../auth/services/permession.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { AuthenticationService } from '../auth/services/authentication.service';
import { ToastService } from '../components/toast/toast.service';
import { routes } from 'src/app/shared/common/routes.consatnt';

@Component({
  selector: 'app-main-layout',
  imports: [CommonModule, RouterOutlet, PagesContainerComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MainLayoutComponent {
  navigationList: NavigationItem[] = [];
  routePath: RoutePath[] = [];
  showTransportationModal = false;
  selectedSchedule: any = null;
  addressesData: any = null;
  currentStudentId: any = null;
  isFromAdd = false;
  places: any = null;
  configurations: PageContainerConfigurations = {
    settingRoute: '',
    logoUrl: 'assets/images/HeaderAdroitLogo.svg',
    profile: {
      profileImg: 'assets/images/empty-profile.svg',
      profileRoute: '/profile',
      userName: 'User Name',
      title: 'Profile',
    },
    hasHeaderFilters: false,
    hasNotificationSection: false,
    hasTools: false,
  };
  signedIn: boolean = false;
  isProfileRoute = false;
  isDispatchRoute = false;
  public isFullStyle = true;

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly permissionsService: PermissionsService,
    readonly _sharedService: SharedService,
    readonly authenticationService: AuthenticationService,
    readonly _toastrService: ToastService,
    private readonly router: Router,
    private readonly cd: ChangeDetectorRef,
  ) {
    if (this.authenticationService.getParamValueQueryString('api_key')) {
      this.isFullStyle = false;
    }
    this.initializeNavigationList();
    this.router.events.subscribe((e) => {
      this.isProfileRoute = this.router.url === '/profile';
      this.isDispatchRoute = this.router.url.includes('/dispatch');

      if (this.isProfileRoute) {
        this.configurations.isProfileRoute = true;
        this.cd.detectChanges();
      } else {
        this.configurations.isProfileRoute = false;
        this.cd.detectChanges();
      }
    });
  }

  public openTransportationSchedule(
    addressList: any,
    placesList: any,
    currentStudentId?: any,
    IsFromAdd = false,
  ): void {
    this.addressesData = addressList;
    this.places = placesList;
    this.currentStudentId = currentStudentId;
    this.showTransportationModal = true;
    this.isFromAdd = IsFromAdd;
    this.cd.detectChanges();
  }

  public closeTransportationModal(): void {
    this.addressesData = null;
    this.places = null;
    this.showTransportationModal = false;
    this.selectedSchedule = null;
  }

  private initializeNavigationList(): void {
    const rawNavigationList: NavigationItem[] = routes;

    this.navigationList = this.filterNavigationList(rawNavigationList);
    this.pageContainerService.setNavigationList(this.navigationList);

    // Set route path mappings for active state detection
    this.routePath = [
      {
        url: '/home',
        routePath: [0], // Maps to Safety navigation item (id: 0)
      },
    ];
    this.pageContainerService.setRoutePath(this.routePath);
  }

  private filterNavigationList(items: NavigationItem[]): NavigationItem[] {
    return items
      .map((item) => {
        // Recursively process children
        const filteredChildren = this.filterNavigationList(item.children || []);

        // Check if the current item has permissions
        // If permissions array is empty, treat as accessible to all
        // If permissions exist, check if user has any of them
        const parentHasPermission =
          !item.permissions ||
          item.permissions.length === 0 ||
          this.permissionsService.hasAnyPermission(item.permissions);

        // Retain item if:
        // - It has its own permissions or no permissions (accessible to all)
        // - It has children with valid permissions (filteredChildren is not empty)
        const redirectUrl = this.permissionsService.getFirstNavigationUrl(
          item.id,
        );

        if (parentHasPermission || filteredChildren.length > 0) {
          return {
            ...item,
            routeUrl: redirectUrl == '' ? item.routeUrl : redirectUrl,
            children: filteredChildren, // Include only filtered children
          };
        }

        // Exclude items without permissions or valid children
        return null;
      })
      .filter((item) => item !== null); // Remove null items
  }
}
